<div id="tc-actions">
    <ng-select
        wcag-label
        [placeholder]="'COMMON.actionsLabel.actions' | translate"
        [inputAttrs]="{'aria-label': 'COMMON.actionsLabel.actions' | translate}"
        [items]="actionsList"
        bindLabel="action"
        bindValue="action"
        (change)="triggerActionController($event)"
        [(ngModel)]="dummyModel"
    >
    </ng-select>
</div>
